'use client'

import { useState } from "react"
import Link from "next/link"
import { motion, useScroll, useMotionValueEvent } from "framer-motion"
import { NavLinks } from "./NavLinks"
import { MobileMenu } from "./MobileMenu"
import { Button } from "../ui/button"
import { cn } from "@/lib/utils"

export const Navbar = () => {
    const [isScrolled, setIsScrolled] = useState(false)
    const [isHidden, setIsHidden] = useState(false)
    const { scrollY } = useScroll()
    const bookingHref =  "/raya/booking"

    useMotionValueEvent(scrollY, "change", (latest) => {
        const previous = scrollY.getPrevious() || 0

        // Background opacity change
        if (latest > 50) {
            setIsScrolled(true)
        } else {
            setIsScrolled(false)
        }

        // Hide on scroll down, show on scroll up
        if (latest > 150 && latest > previous) {
            setIsHidden(true)
        } else {
            setIsHidden(false)
        }
    })

    return (
        <motion.header
            variants={{
                visible: { y: 0 },
                hidden: { y: "-100%" },
            }}
            animate={isHidden ? "hidden" : "visible"}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            className={cn(
                "fixed top-0 left-0 right-0 z-50 transition-all duration-500 py-6 lg:py-8 px-6 lg:px-12",
                isScrolled
                    ? "bg-background/88 backdrop-blur-xl py-4 lg:py-5 border-b border-border/40 shadow-[0_4px_30px_rgba(0,0,0,0.03)]"
                    : "bg-background/72 backdrop-blur-lg border-b border-border/20"
            )}
        >
            <div className="mx-auto flex items-center justify-between">
                <Link
                    href="/"
                    className="group flex flex-col items-start gap-0.5"
                >
                    <span className="font-serif text-2xl lg:text-3xl tracking-tight text-foreground group-hover:text-primary transition-colors">
                        LQ <span className="italic">Studio</span>
                    </span>
                    <span className="text-[7px] uppercase tracking-[1em] text-muted-foreground/60 ml-0.5 group-hover:text-primary/60 transition-colors">
                        Est. 2018
                    </span>
                </Link>

                <div className="hidden lg:flex items-center gap-12">
                    <NavLinks />
                    <Button
                        asChild
                        className="h-12 rounded-full bg-white px-8 text-[11px] uppercase tracking-widest font-semibold text-stone-950 transition-all hover:scale-105 hover:bg-stone-100 active:scale-95"
                    >
                        <Link href={bookingHref}>Book Now</Link>
                    </Button>
                </div>

                <MobileMenu bookingHref={bookingHref} />
            </div>
        </motion.header>
    )
}

export default Navbar
